const React = require("react");

require("./MajorLoading.less");

const MajorLoading = React.createClass({
    render() {
        return (<h1 className="cs-MajorLoading">
            Loading...
        </h1>);
    }
});

module.exports = MajorLoading;


// WEBPACK FOOTER //
// ./src/components/MajorLoading/MajorLoading.jsx